import { css } from '@emotion/react';
import { legacyOnly, newDesignOnly } from 'constants/themes.constants';
import styled from 'types/theme.types';

export const SwitcherContainer = styled.div`
  ${legacyOnly(
    theme => css`
      background: ${theme.primaryWhite};
    `
  )}
  ${newDesignOnly(css`
    background: var(--surface-main-cards);
  `)}
  border-radius: 4px;
  ${legacyOnly(
    theme => css`
      border: 1px solid ${theme.lightGray};
      box-shadow: -1px 6px 14px 0 rgba(80, 80, 80, 0.5);
    `
  )}
  ${newDesignOnly(css`
    border: 1px solid var(--border-primary);
    box-shadow: var(--shadow-dropdown);
  `)}
  font-size: 13px;
  line-height: 17px;
  overflow: hidden;
`;

export const SwitcherItem = styled.div<{ selected?: boolean }>`
  cursor: pointer;
  height: 32px;
  display: flex;
  align-items: center;
  padding-right: 10px;
  font-weight: ${({ selected }) => (selected ? 'bold' : 'normal')};
  ${legacyOnly(
    theme => css`
      color: ${theme.primaryBlack};
    `
  )}
  ${newDesignOnly(css`
    color: var(--text-heading);
  `)}
  ${({ selected, theme }) =>
    selected &&
    (theme.isNewDesign
      ? css`
          background: var(--surface-secondary-background);
        `
      : css`
          background: ${theme.menuGrayLight};
        `)}

  &:hover {
    ${legacyOnly(
      theme => css`
        background: ${theme.menuGray};
      `
    )}
    ${newDesignOnly(css`
      background: var(--surface-main-element-on-card);
    `)}
  }
`;

export const SwitcherRectangle = styled.div<{ selected?: boolean }>`
  height: 100%;
  width: 4px;
  margin-right: 5px;
  ${({ selected, theme }) =>
    theme.isNewDesign
      ? css`
          background: ${selected ? 'var(--surface-primary-action)' : 'transparent'};
        `
      : css`
          background: ${
            selected
              ? `linear-gradient(180deg, #00EDB9 0%, #7FE0D2 30.42%, #45E6F7 50.67%, #1AAEFC 71.51%, #8C85FF 100%)`
              : 'transparent'
          };
        `}
`;
